import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/auth/RouteGuard";

export const Route = createFileRoute("/_authenticated/work-orders")({
  component: () => (
    <RouteGuard module="work_orders"><Outlet /></RouteGuard>
  ),
});
